import React, { useEffect, useState } from "react"
import {
  Button,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { EditableList } from "../../../compnents/list/EditableList"
import { TableRowSelection } from "antd/lib/table/interface"
import { RecordsColumns, RecordsCTYXColumns } from "../columns"
import axios from "axios"
import { useHistory } from "react-router-dom"
import { AXIOS_IP, FillingType } from "../fileUploadService"
import { CTYXFFormModal } from "./CTYXFFormModal"
import { CTYXAgainModal } from "./CTYXAgainModal"

export const RecordsCTYXModal = (props: {
  visible: boolean
  token: string
  filingType: number
  onOk: () => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [CTYXAgainVisible, setCTYXAgainVisible] = useState(false)

  const [CTYXFormVisible, setCTYXFormVisible] = useState(false)

  const [id, setId] = useState<any>()

  const history = useHistory()

  const [pageLoading, setPageLoading] = useState(false)

  const [againId, setAgainId] = useState<any>()

  const [filingRecordId, setFilingRecordId] = useState<any>()

  const [memo, setMemo] = useState<any>()

  const [page, setPage] = useState<any>({
    items: [],
    total: 0,
  })

  const [params, setParams] = useState<any>({
    filingType: 5,
    pageNo: 1,
    pageSize: 10,
  })

  const getData = () => {
    setPageLoading(true)
    axios({
      url: `${AXIOS_IP}/filingReviewMentor/list`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "POST",
      data: { ...params, filingType: props.filingType },
    }).then((res) => {
      setPage({
        ...page,
        items: res.data.data?.records || [],
        total: res.data.data?.total || 0,
      })
      setPageLoading(false)
    })
  }

  useEffect(() => {
    if (!props.visible) return
    getData()
  }, [props.visible, params])

  return (
    <>
      <Modal
        title="传统医学传承管理申请记录"
        width={1200}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        footer={null}
        centered
        maskClosable={false}
      >
        <div>
          <EditableList
            style={{ flex: 1, height: "450px" }}
            scroll={{ x: "30rem" }}
            page={{
              items: page.items,
              current: params.pageNo,
              size: params.pageSize,
              total: page.total,
            }}
            pageSizeOptions={["10", "20", "50", "100"]}
            loading={pageLoading}
            rowKey={(m: any) => m.id}
            columns={RecordsCTYXColumns(
              params.pageSize * (params.pageNo - 1),
              (action: any, t: any) => {
                switch (action) {
                  case "again":
                    setMemo(t.memo)
                    if(t?.filingRecordId) {
                      setAgainId(t.id)
                      setFilingRecordId(t.filingRecordId)
                      setCTYXAgainVisible(true)
                    } else {
                      setId(t?.id)
                      setCTYXFormVisible(true)
                    }
                    props.onCancel()
                    break
                  case "detail":
                    history.push({
                      pathname: "/filingManagementDetail",
                      state: { id: t.id, state: 2, type: FillingType.CTYX, filingType: props.filingType },
                    })
                    break
                }
              }
            )}
            onChangePage={(current, size) =>
              setParams({ ...params, pageNo: current, pageSize: size || 10 })
            }
            sticky
          />
        </div>
      </Modal>

      <CTYXFFormModal
        visible={CTYXFormVisible}
        token={props.token}
        againId={id}
        filingType={props.filingType}
        memo={memo}
        onOk={() => {
          setCTYXFormVisible(false)
        }}
        onCancel={() => setCTYXFormVisible(false)}
      />
      <CTYXAgainModal
        visible={CTYXAgainVisible}
        token={props.token}
        filingType={props.filingType}
        state={2}
        memo={memo}
        id={againId}
        filingRecordId={filingRecordId}
        onOk={() => setCTYXAgainVisible(false)}
        onCancel={() => setCTYXAgainVisible(false)}
      />
    </>
  )
}
